import {Inject, Injectable} from '@angular/core';
import {CplNote} from '../model/cpl-note.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
@Injectable()
export class NoteApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getNotes(typeOfNote: number, typeId: string, notesToInclude: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy));

        return this.http.get(this.baseUri + '/notes/' + typeOfNote.toString() + '/' + typeId + '/' + notesToInclude.toString(), {
            params
        });
    }

    deleteNote(note: CplNote) {
        return this.http.request('delete', this.baseUri + '/note', {
            responseType: 'text',
            body: note
        });
    }

    removeNote(note: CplNote) {
        return this.http.request('delete', this.baseUri + '/note/remove', {
            responseType: 'text',
            body: note
        });
    }

    restoreNote(note: CplNote) {
        return this.http.put(this.baseUri + '/note/restore', note, { responseType: 'text' });
    }

    createNote(note: CplNote) {
        return this.http.post(this.baseUri + '/note', note);
    }
    createRequestNote(note: CplNote) {
        return this.http.post(this.baseUri + '/requestNote', note);
    }
    updateNote(note: CplNote) {
        return this.http.put(this.baseUri + '/note', note);
    }
}